import React, { useState, useCallback } from "react";
import { Box, Typography, Button } from "@mui/material";
import ConfirmDialog from "../../../common/components/ConfirmDialog";
import { buildConfirmationMessage } from "../../helpers/TagComparisonHelper";

export function AddTagsFromHubConfirmation({
  tagIdentifierMap,
  distro,
  lookupValues,
  collisionMode,
  commitAddSelectedTags,
  buttonDisabled,
  selectedHubTags,
}) {
  const [addTagsConfirmOpen, setAddTagsConfirmOpen] = useState(false);
  const [content, setContent] = useState(undefined);

  const handleAddTagsConfirmClose = useCallback(
    async (confirmed) => {
      setAddTagsConfirmOpen(false);
      setContent(undefined);
      if (confirmed === true) {
        commitAddSelectedTags();
      }
    },
    [commitAddSelectedTags]
  );

  const requestAddSelectedTags = useCallback(() => {
    if (!tagIdentifierMap || selectedHubTags.size === 0) {
      return;
    }
    const tagsToAdd = Array.from(selectedHubTags).map(
      (tagIdentifier) => tagIdentifierMap.get(tagIdentifier).tagFromHub
    );
    const messages = buildConfirmationMessage(
      tagsToAdd,
      tagIdentifierMap,
      distro,
      lookupValues,
      collisionMode
    );
    if (messages.length > 0) {
      setContent(
        <Box component='ul' sx={{ pl: 2, m: 0 }}>
          {messages.map((item, i) => (
            <Box component='li' key={i} sx={{ py: 0.5 }}>
              <Typography variant='body2' component='div'>
                {item.confirmationMessage}
              </Typography>
              {item.differences?.length > 0 ? (
                <Box component='ul' sx={{ pl: 2, m: 0, mt: 0.5 }}>
                  {item.differences.map((line, j) => (
                    <Typography
                      key={j}
                      component='li'
                      variant='body2'
                      sx={{ py: 0.125 }}>
                      {line.trim()}
                    </Typography>
                  ))}
                </Box>
              ) : null}
            </Box>
          ))}
        </Box>
      );
    } else {
      setContent(
        <Typography variant='body2'>
          There are no tags that will be added to the grid.
        </Typography>
      );
    }
    setAddTagsConfirmOpen(true);
  }, [tagIdentifierMap, selectedHubTags, lookupValues, distro, collisionMode]);

  return (
    <>
      <Button
        variant='contained'
        onClick={() => requestAddSelectedTags()}
        disabled={buttonDisabled}>
        Add Selected Tags
      </Button>
      <ConfirmDialog
        open={addTagsConfirmOpen}
        onClose={handleAddTagsConfirmClose}
        title={"Add tags from hub?"}
        content={content}
      />
    </>
  );
}
